






import { Component, Vue, Prop } from 'vue-property-decorator'
import Snackbar from '@/components/Snackbar.vue'

@Component<App>({
  components: {
    Snackbar
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: ``,
      titleTemplate: `%s - ${this.$t('login.title')}`
    }
  }
})
export default class App extends Vue {}
